import React, { PropTypes } from 'react';
import { themer } from '@spp/theme-provider';

const ContactUs = ({ url: urlValue, title: titleValue, links, theme, identifier }) => {
    const listItems = links.map((item) => (
        <li key={`${identifier}-${encodeURIComponent(item.linkText)}`}>
            <a href={item.link}>
                {item.spanLinkText && <span>{item.spanLinkText}</span>}
                {item.linkText}
            </a>
        </li>
    ));

    return (
        <aside className={theme.root}>
            <a href={urlValue}>
                <h3 className={theme.title}>{titleValue}</h3>
            </a>
            <ul className={theme['tip-list']} aria-label={titleValue}>
                {listItems}
            </ul>
        </aside>
    );
};

ContactUs.propTypes = {
    identifier: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string.isRequired,
            linkText: PropTypes.string.isRequired,
            spanLinkText: PropTypes.string,
        }),
    ).isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    theme: PropTypes.shape({
        root: PropTypes.string,
        url: PropTypes.string,
    }),
};

ContactUs.defaultProps = {
    identifier: '',
    links: [
        {
            link: 'tel:2200',
            linkText: '2200',
            spanLinkText: 'SMS',
        },
        {
            link: 'tel:22000000',
            linkText: '2200 0000',
            spanLinkText: 'Tlf.',
        },
        {
            link: 'mailto:2200@vg.no',
            linkText: '2200@vg.no',
            spanLinkText: 'E-post',
        },
    ],
    theme: {},
    title: 'Tips oss',
    url: 'https://www.vg.no/tips-oss',
};

export default themer('@vg/ui-contact-us')(ContactUs);



/** WEBPACK FOOTER **
 ** ./src/local-components/ContactUs.js
 **/